export default "__VITE_ASSET__BlW7PS6w__"